import data from "./DimensionAnalysisData";
import { mapState } from "vuex";
import jexcel from "jexcel";
import Tabulator from "tabulator-tables";

export default {
  ...data,
  props: {
    selectedBranch: Array,
    selectedDatasets: Array,
  },
  computed: {
    ...mapState("userProfileVuex", [
      "username",
      "useremail",
      "userImage",
      "datasets",
      "areas",
      "custgroups",
      "nkagroups",
      "custs",
      "prods",
      "branches",
      "roles",
    ]),
    listOne() {
      return this.availableDimArray.filter((i) => i.list === 1);
    },
    listTwo() {
      return this.availableDimArray.filter((i) => i.list === 2);
    },
    datePickerIcon() {
      if (this.showDatePickers === true) {
        return "mdi-arrow-collapse";
      } else {
        return "mdi-arrow-expand";
      }
    },
    reportDimensionIcon() {
      if (this.showReportDimensions === true) {
        return "mdi-arrow-collapse";
      } else {
        return "mdi-arrow-expand";
      }
    },
    reportTableIcon() {
      if (this.showDimensionTable === true) {
        return "mdi-arrow-collapse";
      } else {
        return "mdi-arrow-expand";
      }
    },
    reportSpreadsheetIcon() {
      if (this.showSpreadsheet === true) {
        return "mdi-arrow-collapse";
      } else {
        return "mdi-arrow-expand";
      }
    },
  },
  methods: {
    checkDates() {
      this.showDatePickers = false;
      this.showDimensionTable = true;
      this.showReportDimensions = true;
      this.areaReportLoading = true;
      if (!this.dateFrom1 || !this.dateTo1) {
        alert("Date From 1 and Date From 2 Cannot be Blank");
      } else if (
        this.dateTo1 < this.dateFrom1 ||
        this.dateTo2 < this.dateFrom2 ||
        this.dateTo3 < this.dateFrom3
      ) {
        alert("Date To Cannot be Earlier than Date From");
      } else {
        this.getData(); //call getData()
      }
    },
    getData() {
      const self = this;
      const nodate = "9999-12-31";
      this.resultHeaders = [];
      this.resultArray = [];
      this.spreadsheetData = [];
      this.resultTotalRows = 0;

      //if Date Picker is blank, set to "9999-12-31"
      let datefrom2 = !this.dateFrom2 ? nodate : this.dateFrom2;
      let dateto2 = !this.dateTo2 ? nodate : this.dateTo2;
      let datefrom3 = !this.dateFrom3 ? nodate : this.dateFrom3;
      let dateto3 = !this.dateTo3 ? nodate : this.dateTo3;

      let querydataset = "";
      this.selectedDatasets.forEach((item, index) => {
        if (index < this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} UNION ALL `;
        } else if (index === this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} `;
        }
      });

      gapi.client.load("bigquery", "v2").then(() => {
        //let arrayResult = [];

        console.log("start");

        let sqlquery = `
        WITH querydataset AS (
          ${querydataset}
        )

          SELECT CASE WHEN custgroupcat IS NULL THEN "Uncategorised" ELSE custgroupcat END AS custcat, 
          CASE WHEN custgroup IS NULL THEN "Modern Trade" ELSE custgroup END AS custgroup,
          CASE WHEN nkagroup IS NULL THEN "Non Modern Trade" ELSE nkagroup END AS nkagroup,
            prodgroupcat AS category, brand, uom,  area,  
            CASE WHEN docdate >= "${this.dateFrom1}" 
              AND docdate <= "${this.dateTo1}" THEN SUM(amount) ELSE 0 END AS amt1, 
            CASE WHEN docdate >= "${this.dateFrom1}" 
              AND docdate <= "${this.dateTo1}" THEN SUM(mt) ELSE 0 END AS mt1, 
            CASE WHEN docdate >= "${datefrom2}" 
              AND docdate <= "${dateto2}" THEN SUM(amount) ELSE 0 END AS amt2, 
            CASE WHEN docdate >= "${datefrom2}" 
              AND docdate <= "${dateto2}" THEN SUM(mt) ELSE 0 END AS mt2, 
            CASE WHEN docdate >= "${datefrom3}" 
              AND docdate <= "${dateto3}" THEN SUM(amount) ELSE 0 END AS amt3, 
            CASE WHEN docdate >= "${datefrom3}" 
              AND docdate <= "${dateto3}" THEN SUM(mt) ELSE 0 END AS mt3, 
            FROM querydataset
            WHERE (
              (docdate >= "${this.dateFrom1}" AND docdate <= "${this.dateTo1}") 
              OR 
              (docdate >= "${datefrom2}" AND docdate <= "${dateto2}")
              OR
              (docdate >= "${datefrom3}" AND docdate <= "${dateto3}")
            )   
                ${this.areas}
                ${this.custgroups}
                ${this.nkagroups}
                AND REGEXP_REPLACE(UPPER(custno), ' ', '')  LIKE REGEXP_REPLACE(UPPER("%${this.searchCustNo}%"), ' ', '')
                AND REGEXP_REPLACE(UPPER(custname), ' ', '')  LIKE REGEXP_REPLACE(UPPER("%${this.searchCustName}%"), ' ', '')
                AND REGEXP_REPLACE(UPPER(prodno), ' ', '')  LIKE REGEXP_REPLACE(UPPER("%${this.searchProdNo}%"), ' ', '')
                AND REGEXP_REPLACE(UPPER(shortname), ' ', '')  LIKE REGEXP_REPLACE(UPPER("%${this.searchProdName}%"), ' ', '')
            GROUP BY custcat, custgroup, nkagroup, category, brand, uom,  area,  docdate`;

        let request = gapi.client.bigquery.jobs.query({
          projectId: "1082735422951",
          timeoutMs: "50000",
          query: sqlquery,
          useLegacySql: false,
        });

        request.execute((response) => {
          this.resultTotalRows = parseInt(response.totalRows);
          this.querySchema = response.schema.fields;

          this.processBQResponse(response);
        });
      });
    },
    processBQResponse(response) {
      try {
        if (response.totalRows === "0") {
          alert("No Result for Selected Dates");
        } else {
          //store result Schema info
          response.schema.fields.forEach((item) => {
            this.resultHeaders.push(item.name);
          });

          //process results
          response.rows.forEach((row) => {
            let rowdata = {};
            row.f.forEach((field, index) => {
              //create row object of each row with field name as key
              rowdata[this.resultHeaders[index]] = field.v;
            });

            //push row object to resultArray
            this.resultArray.push(rowdata);
            this.spreadsheetData.push(row);
          });

          if (this.resultTotalRows > this.resultArray.length) {
            //fetch balance/unfetched results
            let jobref = response.jobReference;
            jobref.pageToken = response.pageToken;
            this.fetchBalRows(jobref);
          } else {
            //reset report parameters
            this.displayFilterItem = this.filterItem;
            this.displayFilterBy = this.filterBy;
            this.filterItem = "";
            this.filterBy = "";
            this.searchCustNo = "%";
            this.searchCustName = "%";
            this.searchProdNo = "%";
            this.searchProdName = "%";
            this.updateReport();
            //INSERT SPREADSHEET UPDATE
            //this.prepSpreadsheetData();
          }
        }
      } catch (err) {
        alert(
          `
        1. Check that you are signed in;
        2. Check that the signed in user has access rights;
        3. If above doesn't solve the issue, contact Administrator
             [${err}]`
        );
      }
    },
    fetchBalRows(jobref) {
      let request = gapi.client.bigquery.jobs.getQueryResults(jobref);

      request.execute((response) => {
        //back to process results and append to resultsArray
        this.processBQResponse(response);
      });
    },
    filterDimension(e, item) {
      //push selected filter item to array
      this.filterDimensionArray.push(e);
      //console.log(this.filterDimensionArray);

      //spreadsheet filter
      this.spreadsheetFilter.push([item.item.filterIndex, item.item.name]);
      //console.log(this.spreadsheetFilter);
      this.updateReport();
    },
    unfilterDimension(e) {
      //remove unselected filter item from array
      let itemIndex = this.filterDimensionArray.findIndex((i) => i === e);
      this.filterDimensionArray.splice(itemIndex, 1);

      //spreadsheetfilter
      let itemIndex2 = this.spreadsheetFilter.findIndex((i) => i[1] === e);
      this.spreadsheetFilter.splice(itemIndex2, 1);
      this.updateReport();
    },
    updateReport() {
      //spinner
      this.areaReportLoading = true;

      //update displayed Report Parameters (right of table)
      if (this.filterItem) {
        switch (this.filterBy) {
          case "Cust. No.":
            this.searchCustNo = this.filterItem;
            break;
          case "Cust. Name":
            this.searchCustName = this.filterItem;
            break;
          case "Product Shortname":
            this.searchProdName = this.filterItem;
            break;
          case "Product No.":
            this.searchProdNo = this.filterItem;
            break;
        }
        //fetch data from db again
        //original query don't contain above information
        this.checkDates();
      } else {
        let dimensionArray = [];
        let dimensionData = [];

        //reverse order of selected dimensions array
        //build table from child to parent
        for (let i = this.selectedDimArray.length - 1; i >= 0; i--) {
          dimensionArray.push({
            value: this.selectedDimArray[i].value,
            name: this.selectedDimArray[i].name,
          });
        }

        let dimensionIndex = 0;
        const fetchDimension = (child) => {
          //loop for each dimension
          if (dimensionIndex < dimensionArray.length) {
            dimensionData = [];

            //insert rowkey to each result row
            //rowkey = combi of each dimension's value,eg, "wangipa"
            this.resultArray.forEach((row) => {
              let rowKey = "";
              for (let i = dimensionIndex; i < dimensionArray.length; i++) {
                rowKey += row[dimensionArray[i].value];
              }

              let dataIndex = dimensionData.findIndex((i) => i.key === rowKey);

              //filter rows
              let filterIndex = -1;
              if (this.filterDimensionArray.length !== 0) {
                filterIndex = this.filterDimensionArray.findIndex(
                  (i) => i === row[dimensionArray[dimensionIndex].value]
                );
                if (dimensionIndex === 1) {
                  filterIndex = this.filterDimensionArray.findIndex(
                    (i) => i === row[dimensionArray[dimensionIndex - 1].value]
                  );
                }
                if (dimensionIndex === 2) {
                  filterIndex = this.filterDimensionArray.findIndex(
                    (i) => i === row[dimensionArray[dimensionIndex - 2].value]
                  );
                }
                if (dimensionIndex === 3) {
                  filterIndex = this.filterDimensionArray.findIndex(
                    (i) => i === row[dimensionArray[dimensionIndex - 3].value]
                  );
                }
                if (dimensionIndex === 4) {
                  filterIndex = this.filterDimensionArray.findIndex(
                    (i) => i === row[dimensionArray[dimensionIndex - 4].value]
                  );
                }
                if (dimensionIndex === 5) {
                  filterIndex = this.filterDimensionArray.findIndex(
                    (i) => i === row[dimensionArray[dimensionIndex - 5].value]
                  );
                }
                if (dimensionIndex === 6) {
                  filterIndex = this.filterDimensionArray.findIndex(
                    (i) => i === row[dimensionArray[dimensionIndex - 6].value]
                  );
                }

                /*for (let i = 0; (i = dimensionIndex); i++) {
                  filterIndex = this.filterDimensionArray.findIndex(
                    (i) => i === row[dimensionArray[dimensionIndex - i].value]
                  );
                }*/
              }

              //insert result to reporting data
              if (filterIndex === -1) {
                if (dataIndex === -1) {
                  dimensionData.push({
                    id: rowKey,
                    name: row[dimensionArray[dimensionIndex].value],
                    key: rowKey,
                    custcat: row.custcat,
                    custgroup: row.custgroup,
                    nkagroup: row.nkagroup,
                    category: row.category,
                    brand: row.brand,
                    uom: row.uom,
                    area: row.area,
                    amt1: parseFloat(row.amt1),
                    mt1: parseFloat(row.mt1),
                    amt2: parseFloat(row.amt2),
                    mt2: parseFloat(row.mt2),
                    amt3: parseFloat(row.amt3),
                    mt3: parseFloat(row.mt3),
                    filterIndex: dimensionArray[dimensionIndex].value,
                  });
                } else {
                  /*if (row.brand === "BIHUN") {
                    console.log(
                      row.brand,
                      row.area,
                      dimensionData[dataIndex].mt1
                    );
                  }*/
                  dimensionData[dataIndex].amt1 += parseFloat(row.amt1);
                  dimensionData[dataIndex].mt1 += parseFloat(row.mt1);
                  dimensionData[dataIndex].amt2 += parseFloat(row.amt2);
                  dimensionData[dataIndex].mt2 += parseFloat(row.mt2);
                  dimensionData[dataIndex].amt3 += parseFloat(row.amt3);
                  dimensionData[dataIndex].mt3 += parseFloat(row.mt3);
                }
              }
            });

            //filter Dimension
            /*if (this.filterDimensionArray.length !== 0) {
              this.filterDimensionArray.forEach((item) => {
                dimensionData = dimensionData.filter((i) => i.name !== item);
              });
            }*/

            //calculate computed data for each row
            this.totalmt1 = 0;
            this.totalmt1compare = 0;
            this.totalmt1compareperct = 0;
            this.totalmt2 = 0;
            this.totalmt2compare = 0;
            this.totalmt2compareperct = 0;
            this.totalmt3 = 0;

            dimensionData.forEach((item) => {
              item.amt1 = (Math.round(item.amt1 * 100) / 100).toFixed(2);
              item.mt1 = (Math.round(item.mt1 * 1000) / 1000).toFixed(3);
              item.amt2 = (Math.round(item.amt2 * 100) / 100).toFixed(2);
              item.mt2 = (Math.round(item.mt2 * 1000) / 1000).toFixed(3);
              item.amt3 = (Math.round(item.amt3 * 100) / 100).toFixed(2);
              item.mt3 = (Math.round(item.mt3 * 1000) / 1000).toFixed(3);
              item.compare1mt = (
                Math.round(item.mt1 * 1000) / 1000 -
                Math.round(item.mt2 * 1000) / 1000
              ).toFixed(3);

              let compare1mtperct = (
                ((Math.round(item.mt1 * 1000) / 1000 -
                  Math.round(item.mt2 * 1000) / 1000) /
                  (Math.round(item.mt2 * 1000) / 1000)) *
                100
              ).toFixed(1);

              item.compare1mtperct =
                compare1mtperct === "NaN" || compare1mtperct === "Infinity"
                  ? 0
                  : compare1mtperct;

              item.compare2mt = (
                Math.round(item.mt2 * 1000) / 1000 -
                Math.round(item.mt3 * 1000) / 1000
              ).toFixed(3);
              let compare2mtperct = (
                ((Math.round(item.mt2 * 1000) / 1000 -
                  Math.round(item.mt3 * 1000) / 1000) /
                  (Math.round(item.mt3 * 1000) / 1000)) *
                100
              ).toFixed(1);

              item.compare2mtperct =
                compare2mtperct === "NaN" || compare2mtperct === "Infinity"
                  ? 0
                  : compare2mtperct;

              //if result has child
              if (child) {
                child.forEach((row) => {
                  //generate parent key for each child
                  let parentKey = "";
                  for (let i = dimensionIndex; i < dimensionArray.length; i++) {
                    parentKey += row[dimensionArray[i].value];
                  }
                  row.parentkey = parentKey;
                });
                //filter child items
                let childItem = child.filter((i) => i.parentkey === item.key);

                //sort report data
                if (this.sortItem === "name" || !this.sortItem) {
                  if (this.sortType === "Descending") {
                    item.children = childItem.sort((a, b) =>
                      b.name.localeCompare(a.name)
                    );
                    item._children = childItem.sort((a, b) =>
                      b.name.localeCompare(a.name)
                    );
                  } else {
                    item.children = childItem.sort((a, b) =>
                      a.name.localeCompare(b.name)
                    );
                    item._children = childItem.sort((a, b) =>
                      a.name.localeCompare(b.name)
                    );
                  }
                } else {
                  if (this.sortType === "Descending") {
                    item.children = childItem.sort(
                      (a, b) => b[this.sortItem] - a[this.sortItem]
                    );
                    item._children = childItem.sort(
                      (a, b) => b[this.sortItem] - a[this.sortItem]
                    );
                  } else {
                    item.children = childItem.sort(
                      (a, b) => a[this.sortItem] - b[this.sortItem]
                    );
                    item._children = childItem.sort(
                      (a, b) => a[this.sortItem] - b[this.sortItem]
                    );
                  }
                }
              }
              //grand total for root dimension
              if (dimensionIndex === dimensionArray.length - 1) {
                this.totalmt1 += parseFloat(item.mt1);
                this.totalmt2 += parseFloat(item.mt2);
                this.totalmt3 += parseFloat(item.mt3);
              }
            });

            dimensionIndex++;
            //console.log(dimensionData);
            fetchDimension(dimensionData);
          } else {
            //if all dimensions processed, do sorting
            this.areaReportArray = [];

            if (this.sortItem === "name" || !this.sortItem) {
              if (this.sortType === "Descending") {
                this.areaReportArray = dimensionData.sort((a, b) =>
                  b.name.localeCompare(a[this.sortItem])
                );
              } else {
                this.areaReportArray = dimensionData.sort((a, b) =>
                  a.name.localeCompare(b[this.sortItem])
                );
              }
            } else {
              if (this.sortType === "Descending") {
                this.areaReportArray = dimensionData.sort(
                  (a, b) => b[this.sortItem] - a[this.sortItem]
                );
              } else {
                this.areaReportArray = dimensionData.sort(
                  (a, b) => a[this.sortItem] - b[this.sortItem]
                );
              }
            }

            //compute grand totals
            this.totalmt1compare = (
              Math.round(this.totalmt1 * 1000) / 1000 -
              Math.round(this.totalmt2 * 1000) / 1000
            ).toFixed(3);

            this.totalmt1compareperct = (
              ((Math.round(this.totalmt1 * 1000) / 1000 -
                Math.round(this.totalmt2 * 1000) / 1000) /
                (Math.round(this.totalmt3 * 1000) / 1000)) *
              100
            ).toFixed(1);

            this.totalmt2compare = (
              Math.round(this.totalmt2 * 1000) / 1000 -
              Math.round(this.totalmt3 * 1000) / 1000
            ).toFixed(3);

            this.totalmt2compareperct = (
              ((Math.round(this.totalmt2 * 1000) / 1000 -
                Math.round(this.totalmt3 * 1000) / 1000) /
                (Math.round(this.totalmt3 * 1000) / 1000)) *
              100
            ).toFixed(1);

            this.totalmt1 = (Math.round(this.totalmt1 * 1000) / 1000).toFixed(
              3
            );
            this.totalmt2 = (Math.round(this.totalmt2 * 1000) / 1000).toFixed(
              3
            );
            this.totalmt3 = (Math.round(this.totalmt3 * 1000) / 1000).toFixed(
              3
            );

            //spinner
            this.areaReportLoading = false;
            //INSERT SPREADSHEET UPDATE?????????
            //this.prepSpreadsheetData();
          }
        };
        fetchDimension();

        this.processTableDefinition(this.areaReportArray);
        this.prepSpreadsheetData();
      }
    },
    prepSpreadsheetData() {
      //console.log(this.spreadsheetData);
      let rowsIndex = [];
      let tempdata = [];

      this.selectedDimArray.forEach((item) => {
        let rowSchemaIndex = this.querySchema.findIndex(
          (i) => i.name === item.value
        );
        rowsIndex.push(rowSchemaIndex);
      });

      this.spreadsheetData.forEach((item) => {
        let schemaKey = "";
        let rowsName = [];
        rowsIndex.forEach((i) => {
          schemaKey = schemaKey.concat(item.f[i].v);
          rowsName.push(item.f[i].v);
        });

        let tempdataIndex = tempdata.findIndex(
          (i) => i.schemaKey === schemaKey
        );
        if (tempdataIndex === -1) {
          tempdata.push({
            schemaKey: schemaKey,
            ...rowsName,
            mt1: parseFloat(item.f[8].v),
            compare1mt: 0,
            compare1mtperct: 0,
            mt2: parseFloat(item.f[10].v),
            compare2mt: 0,
            compare2mtperct: 0,
            mt3: parseFloat(item.f[12].v),
          });
        } else {
          //tempdata[tempdataIndex].amt1 += parseFloat(item.f[7].v);
          tempdata[tempdataIndex].mt1 += parseFloat(item.f[8].v);
          //tempdata[tempdataIndex].amt2 += parseFloat(item.f[9].v);
          tempdata[tempdataIndex].mt2 += parseFloat(item.f[10].v);
          //tempdata[tempdataIndex].amt3 += parseFloat(item.f[11].v);
          tempdata[tempdataIndex].mt3 += parseFloat(item.f[12].v);
        }
      });

      tempdata.forEach((item) => {
        delete item.schemaKey;

        //item.amt1 = (Math.round(item.amt1 * 100) / 100).toFixed(2);
        item.mt1 = (Math.round(item.mt1 * 1000) / 1000).toFixed(3);
        //item.amt2 = (Math.round(item.amt2 * 100) / 100).toFixed(2);
        item.mt2 = (Math.round(item.mt2 * 1000) / 1000).toFixed(3);
        //item.amt3 = (Math.round(item.amt3 * 100) / 100).toFixed(2);
        item.mt3 = (Math.round(item.mt3 * 1000) / 1000).toFixed(3);
        item.compare1mt = (
          Math.round(item.mt1 * 1000) / 1000 -
          Math.round(item.mt2 * 1000) / 1000
        ).toFixed(3);

        let compare1mtperct = (
          ((Math.round(item.mt1 * 1000) / 1000 -
            Math.round(item.mt2 * 1000) / 1000) /
            (Math.round(item.mt2 * 1000) / 1000)) *
          100
        ).toFixed(1);

        item.compare1mtperct =
          compare1mtperct === "NaN" || compare1mtperct === "Infinity"
            ? 0
            : compare1mtperct;

        item.compare2mt = (
          Math.round(item.mt2 * 1000) / 1000 -
          Math.round(item.mt3 * 1000) / 1000
        ).toFixed(3);
        let compare2mtperct = (
          ((Math.round(item.mt2 * 1000) / 1000 -
            Math.round(item.mt3 * 1000) / 1000) /
            (Math.round(item.mt3 * 1000) / 1000)) *
          100
        ).toFixed(1);

        item.compare2mtperct =
          compare2mtperct === "NaN" || compare2mtperct === "Infinity"
            ? 0
            : compare2mtperct;
      });

      //filterData
      this.spreadsheetFilter.forEach((item) => {
        let selectedDimArrayIndex = this.selectedDimArray.findIndex(
          (i) => i.value === item[0]
        );

        tempdata = tempdata.filter((i) => i[selectedDimArrayIndex] !== item[1]);
      });
      //sort by area, using localeCompare as area is string
      tempdata = tempdata.sort(
        (a, b) =>
          a[0].localeCompare(b[0]) ||
          a[1].localeCompare(b[1]) ||
          a[2].localeCompare(b[2])
      );

      document.getElementById("dimensionSpreadsheet").innerHTML = "";
      //console.log(tempdata);
      this.renderSpreadsheet(rowsIndex, tempdata);
      //this.prepTableData(tempdata);
    },
    /*prepTableData() {

      this.processTableDefinition(this.areaReportArray);
    },*/
    processTableDefinition(tempdata) {
      this.tableColumns = [];
      this.tableData = [];

      this.tableData = tempdata;

      this.tableColumns = [
        {
          title: this.selectedDimArray[0].name,
          field: "name",
          width: "300",
        },
        {
          title: "MT 1",
          field: "mt1",
          hozAlign: "right",
        },
        {
          title: "+/- 1",
          field: "compare1mt",
          hozAlign: "right",
        },
        {
          title: "+/- % 1",
          field: "compare1mtperct",
          hozAlign: "right",
        },
        {
          title: "MT 2",
          field: "mt2",
          hozAlign: "right",
        },
        {
          title: "+/- 2",
          field: "compare2mt",
          hozAlign: "right",
        },
        {
          title: "+/- % 2",
          field: "compare2mtperct",
          hozAlign: "right",
        },
        {
          title: "MT 3 (ref. only)",
          field: "mt3",
          hozAlign: "right",
        },
      ];
      this.createTable();
    },
    createTable() {
      this.table = null;

      this.table = new Tabulator("#dimensionTable", {
        height: "100%",
        movableColumns: false,
        dataTree: true,
        layout: "fitColumns",
        layout: "fitDataFill",
        //layout: "fitDataStretch",
        responsiveLayout: "collapse",
        //responsiveLayoutCollapseStartOpen: false,
        pagination: "local",
        paginationSize: 50,
        paginationSizeSelector: [5, 10, 20, 30, 40, 50, 100, 500, 1000],
        clipboard: true,
        clipboardCopyStyled: false,
        //rowContextMenu: this.tableContextMenu,
        columns: this.tableColumns,
        data: this.tableData,
      });
    },
    renderSpreadsheet(headersIndex, sheetdata) {
      let headers = [];

      this.selectedDimArray.forEach((item) => {
        headers.push({
          title: item.name,
          width: item.width,
          align: "left",
        });
      });

      headers.push(
        { title: "MT 1", width: 100, align: "right" },
        { title: "+/- 1", width: 100, align: "right" },
        { title: "+/- % 1", width: 100, align: "right" },
        { title: "MT 2", width: 100, align: "right" },
        { title: "+/- 2", width: 100, align: "right" },
        { title: "+/- % 2", width: 100, align: "right" },
        { title: "MT 3", width: 200, align: "right" }
      );

      let table1 = jexcel(document.getElementById("dimensionSpreadsheet"), {
        data: sheetdata,
        columns: headers,
        tableOverflow: true,
        lazyLoading: true,
        loadingSpin: true,
        tableHeight: "400px",
        nestedHeaders: [
          [
            {
              title: "Item",
              colspan: `${this.selectedDimArray.length}`,
            },
            {
              title: `${this.dateFrom1} to ${this.dateTo1}`,
              colspan: "3",
            },
            {
              title: `${this.dateFrom2} to ${this.dateTo2}`,
              colspan: "3",
            },
            {
              title: `${this.dateFrom3} to ${this.dateTo3}`,
              colspan: "1",
            },
          ],
          [],
        ],
      });

      if (this.selectedDimArray.length > 1) {
        for (let i = 0; i < this.selectedDimArray.length - 1; i++) {
          let rowCount = 0;
          let rowNos = 1;
          let colName = String.fromCharCode("A".charCodeAt(0) + i);
          let dimIndex = i;

          for (let i = 0; i < sheetdata.length; i++) {
            if (i !== sheetdata.length - 1) {
              if (sheetdata[i][dimIndex] === sheetdata[i + 1][dimIndex]) {
                rowCount += 1;
              } else {
                rowCount += 1;
                if (rowCount > 1) {
                  table1.setMerge(`${colName}${rowNos}`, 0, rowCount);
                  table1.setStyle({
                    [colName + rowNos]: "vertical-align:top",
                  });
                }
                rowNos += rowCount;
                rowCount = 0;
              }
            } else {
              rowCount += 1;
              if (rowCount > 1) {
                table1.setMerge(`${colName}${rowNos}`, 0, rowCount);
                table1.setStyle({
                  [colName + rowNos]: "vertical-align:top",
                });
              }
              rowNos += rowCount;
              rowCount = 0;
            }
          }
        }
      }
    },
    startDrag: (evt, item, list) => {
      let movedObject = JSON.stringify(item);
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("itemID", movedObject);
      evt.dataTransfer.setData("list", list);
    },
    onDrop(evt, list) {
      const itemID = JSON.parse(evt.dataTransfer.getData("itemID"));
      const listID = evt.dataTransfer.getData("list");

      let oldIndex = this[listID].findIndex((i) => i.name === itemID.name);
      let newIndex = this[listID].findIndex(
        (i) => i.name === evt.target.innerText.trim()
      );

      if (newIndex === -1) {
        this[list].push(itemID);
        this[listID].splice([oldIndex], 1);
      } else {
        this[listID].splice([oldIndex], 1);
        this[listID].splice([newIndex], 0, itemID);
      }
      this.updateReport();
      //this.prepSpreadsheetData();
    },
  },
  mounted() {
    //set default Date 1
    let moment = require("moment");

    this.dateFrom1 = moment(new Date())
      .startOf("month")
      .format("YYYY-MM-DD");

    this.dateTo1 = moment(new Date())
      .endOf("month")
      .format("YYYY-MM-DD");

    this.dateFrom2 = moment(new Date())
      .subtract(1, "month")
      .startOf("month")
      .format("YYYY-MM-DD");

    this.dateTo2 = moment(new Date())
      .subtract(1, "month")
      .endOf("month")
      .format("YYYY-MM-DD");

    this.dateFrom3 = moment(new Date())
      .subtract(2, "month")
      .startOf("month")
      .format("YYYY-MM-DD");

    this.dateTo3 = moment(new Date())
      .subtract(2, "month")
      .endOf("month")
      .format("YYYY-MM-DD");
  },
};
